import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

const DEFAULT_TIMEOUT_MS = 4500;

/**
 * Thin wrapper around ngx-toastr so the rest of the app depends on a small,
 * typed API (success/error/warning/info) instead of the toast library directly.
 * Every toast uses the same fixed look — no per-call options.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastr = inject(ToastrService);

  success(message: string): void {
    this.show('success', message);
  }

  error(message: string): void {
    this.show('error', message);
  }

  warning(message: string): void {
    this.show('warning', message);
  }

  info(message: string): void {
    this.show('info', message);
  }

  clear(): void {
    this.toastr.clear();
  }

  private show(type: ToastType, message: string): void {
    // Second positional arg is `title` in ngx-toastr's actual signature — always
    // undefined now that we don't support titles, so the config lands in `override`.
    this.toastr[type](message, undefined, {
      timeOut: DEFAULT_TIMEOUT_MS,
      closeButton: true,
      progressBar: true,
      tapToDismiss: false,
      toastClass: 'app-toast',
    });
  }
}
